import lodash from 'lodash';
import { BindAll } from 'lodash-decorators';
import { EnumAPI } from '../../apis';
import { BaseModel, BasesController } from '../bases';
@BindAll()
export class ChannelSearchController extends BasesController {
  constructor() {
    super();
    this.reset({
      dataKey: 'productId',
      infinite: true,
      pagination: this.paginationApi,
      paginationParams: {
        currentKey: 'pageNo',
        pageSizeKey: 'pageSize',
        response: {
          valueGetter: (res) => {
            const dataSource = lodash.get(
              res,
              this.tabIndex == 0 ? 'list.productList' : 'list',
              [],
            );
            return {
              dataSource: dataSource,
              total: lodash.get(res, 'count', 0),
            };
          },
        },
      },
    });
  }
  Modal = new BaseModel({ type: 'object' });
  tagBar(index) {
    if (this.tabIndex == index) return;
    this.reset({
      dataKey: 'productId',
      infinite: true,
      pagination:
        index == 0 ? EnumAPI.product_search : EnumAPI.product_channels_search,
      paginationParams: {
        currentKey: 'pageNo',
        pageSizeKey: 'pageSize',
        response: {
          valueGetter: (res) => {
            const dataSource = lodash.get(
              res,
              this.tabIndex == 0 ? 'list.productList' : 'list',
              [],
            );
            return {
              dataSource: dataSource,
              total: lodash.get(res, 'count', 0),
            };
          },
        },
      },
    });
    this.Modal.merge({ tabIndex: index });
  }
  get paginationApi() {
    return this.tabIndex == 0
      ? EnumAPI.product_search
      : EnumAPI.product_channels_search;
  }
  get tabIndex() {
    return this.Modal.get('tabIndex', 0);
  }
  setSearchParams(val) {
    if (this.tabIndex == 0) {
      return {
        searchKey: val,
      };
    }
    return {
      search: {
        searchKey: val,
      },
    };
  }
}
